import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { Router } from '@angular/router';
import { UserDataService } from './shared/services/user-data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private route: Router,
    private location: Location,
    private firestore: AngularFirestore,
    private userDataService: UserDataService
  ) {}

  ngOnInit(): void {
    const user = sessionStorage.getItem('userUID') || undefined;
    const currentUrl = this.location.path(true);
    if (!!user) {
      this.userDataService.setUserUID(user);
      if (currentUrl === null) {
        this.route.navigate(['./layout']);
      } else {
        this.route.navigateByUrl(currentUrl);
      }
    } else {
      this.route.navigate(['./login']);
    }
  }
}
